<template>
	<div>
		<template v-if="coronavirus">
			<slot name="covid" />
		</template>
		<template v-else>
			<slot name="current" />
		</template>
	</div>
</template>

<script>
import CONSTANTS from "@/config/constants";

export default {
	name: "COVID19",
	data() {
		return {
			coronavirus: CONSTANTS.COVID_19 
		};
	}
};
</script>
